import React from 'react'

const aStyle = { color: '#40c0c0' }

const Link = ({ url, content }) => {
  return <a className='font-medium text-blue-600 dark:text-blue-500 hover:underline cursor-pointer' style={aStyle} href={url} target='_blank' rel='noreferrer'>{content}</a>
}

export default Link
